/* External */
import { useEffect, useRef } from 'react';

/* Ott-common */
import { useGetSync } from '@dtvgo/react-utils';

/* Utils */
import { useShowDisconnectedMessage } from './ConnectionStatusProvider';

export default function useOnDisconnectedMessageHide(callback) {
  const disconnectedMessageShownRef = useRef(false);
  const showDisconnectedMessage = useShowDisconnectedMessage();
  const getCallback = useGetSync(callback);

  useEffect(() => {
    if (!showDisconnectedMessage && disconnectedMessageShownRef?.current) {
      const currentCallback = getCallback();
      currentCallback();
    }
    disconnectedMessageShownRef.current = showDisconnectedMessage;
  }, [getCallback, showDisconnectedMessage]);
}
